import { render } from "./LooseThoughts.vue?vue&type=template&id=3aa86bac&scoped=true"
import script from "./LooseThoughts.vue?vue&type=script&lang=js"
export * from "./LooseThoughts.vue?vue&type=script&lang=js"

import "./LooseThoughts.vue?vue&type=style&index=0&id=3aa86bac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa86bac"]])

export default __exports__